// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/product_price.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_subscriptions_v1_resources_plan_recurrence_kind } from "./plan_recurrence_kind_pb.js";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/product_price.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_product_price = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvcHJvZHVjdF9wcmljZS5wcm90bxInc3R1ZHlvLnRvZGF5LnN1YnNjcmlwdGlvbnMudjEucmVzb3VyY2VzIr8BCgxQcm9kdWN0UHJpY2USCgoCaWQYASABKAkSDQoFcHJpY2UYAiABKA0SEAoIY3VycmVuY3kYAyABKAkSSQoEa2luZBgEIAEoDjI7LnN0dWR5by50b2RheS5zdWJzY3JpcHRpb25zLnYxLnJlc291cmNlcy5QbGFuUmVjdXJyZW5jZUtpbmQSIgoaY2FuX3N1YnNjcmliZV93aXRoX2ludm9pY2UYBSABKAgSEwoLaXNfYXJjaGl2ZWQYBiABKAhCL6oCLFN0dWR5by5Ub2RheS5TdWJzY3JpcHRpb25zLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_subscriptions_v1_resources_plan_recurrence_kind]);

/**
 * Describes the message studyo.today.subscriptions.v1.resources.ProductPrice.
 * Use `create(ProductPriceSchema)` to create a new message.
 */
export const ProductPriceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_subscriptions_v1_resources_product_price, 0);

